import React, { useState } from "react";
import {
  Container,
  Content,
  IconsWrapper,
  MenuIconButton,
  IconLink,
  AppBarLogo,
  AppBarText,
  AppBarLogoLink,
  SigninButton,
  StyledIcon,
  CloseMenuArea,
  SearchIconWrapper,
} from "./styles";
import useLockedBody from "utils/useLockedBody";
import SearchBar from "./SearchBar";
import DrawerNavigator from "./DrawerNavigator";
import SignInModal from "./SignInModal";

const AppBarComponent = ({
  appBarDrawerItems = [],
  appBarSocialItems = [],
  appBarTitle = "",
  appBarTitleLogo = null,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenSignin, setIsOpenSignin] = useState(false);
  const [isOpenSearch, setIsOpenSearch] = useState(false);

  const [locked, setLocked] = useLockedBody();

  const handleClickSearchIcon = () => {
    setIsOpenSearch((prev) => !prev);
    isOpen && setIsOpen(false);
  };

  const handleCloseAction = () => {
    if (isOpen || isOpenSignin) {
      setLocked(false);
      isOpen && setIsOpen(false);
      isOpenSignin && setIsOpenSignin(false);
    }
  };

  const handleClickOutside = () => {
    if (isOpen || isOpenSearch) {
      setLocked(false);
      setIsOpen(false);
      setIsOpenSearch(false);
    }
  };

  const handleClickHamburger = () => {
    locked ? setLocked(false) : setLocked(true);
    setIsOpen((prev) => !prev);
    isOpenSearch && setIsOpenSearch(false);
  };

  const handleClickSignin = () => {
    locked ? setLocked(false) : setLocked(true);
    setIsOpen(false);
    setIsOpenSignin((prev) => !prev);
  };

  const TitleComponent = appBarTitleLogo ? (
    <AppBarLogo item={appBarTitleLogo} objectFit="contain" />
  ) : (
    <AppBarText>{appBarTitle}</AppBarText>
  );

  return (
    <Container>
      <CloseMenuArea
        isOpen={isOpen || isOpenSearch}
        onClick={handleClickOutside}
      />
      <Content>
        <MenuIconButton
          size={25}
          toggled={isOpen}
          toggle={handleClickHamburger}
          color="#382e2b"
          direction="left"
        />
        <AppBarLogoLink href={"/"}>{TitleComponent}</AppBarLogoLink>
        <IconsWrapper>
          <SigninButton onClick={handleClickSignin}>
            <IconLink type={"User"} />
          </SigninButton>
          <SearchIconWrapper onClick={handleClickSearchIcon}>
            <StyledIcon type={"Search"} />
          </SearchIconWrapper>
        </IconsWrapper>
      </Content>
      {isOpenSignin && (
        <SignInModal isOpen={isOpenSignin} closeModal={handleCloseAction} />
      )}
      {isOpenSearch && (
        <SearchBar closeHandler={() => setIsOpenSearch(false)} />
      )}
      <DrawerNavigator
        siteNavItems={appBarDrawerItems}
        socialLinks={appBarSocialItems}
        handleClickOutside={handleCloseAction}
        isOpen={isOpen}
      />
    </Container>
  );
};

export default AppBarComponent;
